import HttpRequest from '@/libs/axios'
const baseUrl = process.env.HOST

const axios = new HttpRequest(baseUrl)
export default axios



// WEBPACK FOOTER //
// ./src/libs/api.request.js